module.exports = __webpack_public_path__ + "static/media/ankleAndFoot-quizz.5c787ab6.jpg";